import { dispatchPromise } from './action-helpers';

export const getAppProps = () => {
    return dispatchPromise({
        type: 'APP_PROPS_FETCH_REQUESTED'
    });   
}

export const activateUserDetailed = (userId, type = 'flyout', tab, extraData) => {
    return dispatchPromise({
        type: 'USER_DETAILED_ACTIVATE_REQUESTED',
        payload: {
            userId,
            type,
            tab,
            extraData
        }
    });
}

export const deactivateUserDetailed = () => {
    return dispatchPromise({
        type: 'USER_DETAILED_DEACTIVATE_REQUESTED'
    });
}

export const toggleCreateProject = visible => {
    return dispatchPromise({
        type: 'CREATE_PROJECT_TOGGLE',
        payload: { visible }
    });
}

export const setGlobalProgress = (progress, title) => {
    return dispatchPromise({
        type: 'SET_GLOBAL_PROGRESS',
        payload: { progress, title }
    });
}

export const setSocketErrorState = hasError => {
    return dispatchPromise({
        type: 'SET_SOCKET_ERROR_STATE',
        payload: { hasError }
    });
}
